import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { LocaleService } from '../services/locale.service';
import { TerminologyTestingStateService } from '../services/terminology-testing-state.service';

@Injectable({ providedIn: 'root' })
export class PermissionsInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private terminologyTestingState: TerminologyTestingStateService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const permissionsToken = this.authService.getPermissionsToken();
    const requestLocale = LocaleService.normalize(
      this.userService.localeSub.value || localStorage.getItem('ehr.locale') || 'en',
    );
    let clonedRequest = req.clone({
      setHeaders: {
        'Accept-Language': requestLocale,
      },
    });

    if (permissionsToken) {
      clonedRequest = clonedRequest.clone({
        setHeaders: {
          'X-Backend-Token': permissionsToken,
        },
      });
    }

    return next.handle(clonedRequest).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const currentLocale = LocaleService.normalize(
            this.userService.localeSub.value || localStorage.getItem('ehr.locale') || 'en',
          );
          if (requestLocale === currentLocale) {
            this.terminologyTestingState.updateFromResponseMode(
              event.headers.get('X-EHR-Terminology-Mode'),
            );
          }
        }
      }),
    );
  }
}
